import WizardSummary from '../../../../../../../common/wizard/WizardSummary.jsx'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useAccountType from '../../../../../../../hooks/useAccontType.js'
import { Alert } from 'react-bootstrap'

export const Podsumowanie = (props) => {
    const { tryb } = useParams()
    const { id, wzor } = useSelector((store) => store.wizard)
    const [accountType] = useAccountType()
    const wersja = props.wiz?.form?.wersja

    const hasErrors = Object.keys(props?.wiz?.summary?.error || {}).length > 0

    return (
        <div>
            <WizardSummary
                failed={'Wystąpił błąd podczas walidacji danych.'}
                loading={'Walidowanie danych...'}
                success={'Dane zwalidowane poprawnie.'}
                wiz={props.wiz}
                pdfButton={tryb === 'edycja'}
                module={'rejestr'}
                pdfBodyData={{
                    id,
                    userType: accountType,
                    wzor: wzor ?? 'kp1',
                    tmp: 'tmp',
                    table: 'rejestr',
                    wersja: wersja ?? 1,
                }}
            />
            {tryb === 'edycja' && !hasErrors && (
                <Alert variant="info" className="mt-3">
                    <i className="bi bi-info-circle me-2"></i>
                    Po wybraniu opcji <strong>"Zapisz i złóż"</strong> możliwość edycji dokumentu zostanie zablokowana.
                </Alert>
            )}
        </div>
    )
}

Podsumowanie.propTypes = {
    wiz: PropTypes.any,
}
